import * as yup from "yup";

export const getSchema = (includeRoles: boolean, isChildOfJointAccount: boolean) =>
  yup.object().shape({
    ...{
      ownershipPercentage: isChildOfJointAccount
        ? yup.number().nullable()
        : yup.number().when("isOwner", {
            is: true,
            then: (schema) =>
              schema
                .required("Ownership percentage is required if owner is selected")
                .typeError("Ownership percentage must be a number")
                .positive("Ownership percentage must be positive"),
          }),
      isOwner: yup.boolean(),
      isController:
        includeRoles && !isChildOfJointAccount
          ? yup
              .boolean()
              .test(
                "at-least-one-role",
                "At least one role must be selected",
                function (value) {
                  const { isOwner } = this.parent;
                  return isOwner === true || value === true;
                },
              )
          : yup.boolean(),
    },
    ...{
      taxIdType: yup.string().nullable(),
      taxId: yup.string().min(5, "Tax Id must be at least 5 characters"),
      // Address fields
      streetLine1: yup.string(),
      streetLine2: yup.string(),
      city: yup.string(),
      stateOrProvince: yup.string(),
      country: yup.string().required("Country required"),
      zipCode: yup.string(),
      // individual required fields
      firstName: yup.string().required("First name required"),
      lastName: yup.string().required("Last name required"),
    },
  });
